module.exports = __webpack_public_path__ + "media/images/members/explosion-black-0af6052ab1fadeebd7db294dcc0f9889.png";